import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faEdit,
  faTrash,
  faEllipsisH,
  faCircle,
  faUsersCog,
  faCheck,
  faSpinner,
  faMinus,
  faKey,
  faBars,
  faUser,
  faCrown,
  faPlus,
  faQuestionCircle,
  faExclamationTriangle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

// FaSolid
library.add(faChevronRight);
library.add(faSearch);
library.add(
  faUsers,
  faChevronUp,
  faChevronDown,
  faEdit,
  faEllipsisH,
  faTrash,
  faCircle,
  faUsersCog,
  faCheck,
  faSpinner,
  faMinus,
  faKey,
  faBars,
  faUser,
  faCrown,
  faPlus,
  faQuestionCircle,
  faExclamationTriangle,
  faCheckCircle
);
